import { faCalendar, faClock } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker, TimePicker } from "antd";
import { useEffect } from "react";
import dayjs from "../helpers/dayjsSetup";

const CustomDateTimePicker = ({
  type = "datetime", // "datetime"(default), "date", or "time"
  timeDefault = "05:00",
  minuteStep = 15,
  form,
  itemName,
  ...restProps
}) => {
  const timeConfig = {
    defaultValue: dayjs(timeDefault, "HH:mm"),
    minuteStep,
  };

  const value = form?.getFieldValue(itemName);
  useEffect(() => {
    if (form && itemName) {
      const currentValue = form.getFieldValue(itemName);
      if (!currentValue) {
        if (type === "time") {
          form.setFieldValue(itemName, timeConfig.defaultValue);
        } else if (type === "datetime") {
          form.setFieldValue(itemName, dayjs().hour(5).minute(0));
        }
      }
    }
  }, [form, itemName, type]);

  if (type === "date") {
    return (
      <DatePicker
        placeholder=""
        suffixIcon={
          <FontAwesomeIcon
            icon={faCalendar}
            className="text-xl text-[#545454]"
          />
        }
        value={value}
        format={(val) => val.format("DD MMM YYYY").toUpperCase()}
        {...restProps}
      />
    );
  } else if (type === "time") {
    return (
      <TimePicker
        placeholder=""
        suffixIcon={
          <FontAwesomeIcon
            icon={faClock}
            className="text-xl text-[#545454]"
          />
        }
        value={value}
        {...timeConfig}
        format="HH:mm"
        showSecond={false}
        {...restProps}
      />
    );
  } else {
    return (
      <DatePicker
        placeholder=""
        suffixIcon={
          <FontAwesomeIcon
            icon={faCalendar}
            className="text-xl text-[#545454]"
          />
        }
        value={value}
        showTime={timeConfig}
        format={(val) => val.format("DD MMM YYYY HH:mm").toUpperCase()}
        showSecond={false}
        {...restProps}
      />
    );
  }
};

export default CustomDateTimePicker;